module.exports = __webpack_public_path__ + "static/media/youtube.2285cad5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/youtube.svg
// module id = 219
// module chunks = 0